import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { loginApi } from '../../api/auth';

export const loginThunk = createAsyncThunk('auth/login', async (payload, { rejectWithValue }) => {
  try {
    const res = await loginApi(payload);
    return res.data;
  } catch (e) {
    return rejectWithValue({ message: e.response?.data?.message || 'Login failed', status: e.response?.status });
  }
});

const stored = (() => {
  try {
    return { user: JSON.parse(localStorage.getItem('user')), token: localStorage.getItem('token') };
  } catch { return { user: null, token: null }; }
})();

const authSlice = createSlice({
  name: 'auth',
  initialState: { user: stored.user, token: stored.token, isLoading: false, error: null },
  reducers: {
    logout(state) {
      state.user = null;
      state.token = null;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    },
    setUser(state, action) {
      state.user = action.payload;
      localStorage.setItem('user', JSON.stringify(action.payload));
    },
  },
  extraReducers: (b) => {
    b.addCase(loginThunk.pending, (s) => { s.isLoading = true; s.error = null; });
    b.addCase(loginThunk.fulfilled, (s, a) => {
      s.isLoading = false;
      const token = a.payload.authorisation?.token ?? a.payload.authorization?.token ?? a.payload.token;
      s.user  = a.payload.user;
      s.token = token;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(a.payload.user));
    });
    b.addCase(loginThunk.rejected, (s, a) => { s.isLoading = false; s.error = a.payload?.message || a.payload; });
  },
});

export const { logout, setUser } = authSlice.actions;
export default authSlice.reducer;
